import "./App.css";
import { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Box,
  Card,
  TextField,
  Backdrop,
  CircularProgress,
  Select,
  MenuItem,
  Alert,
  Button,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Fab,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import { saveAs } from "file-saver";
import DownloadIcon from "@mui/icons-material/Download";
import Header from "./components/Header";
import Result from "./components/Result";
import Login from "./components/Login";
import HistoryDrawer from "./components/History";
import Usage from "./components/Usage";
import axios from "axios";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import { countChineseCharacters, displayDate } from "./components/action";
import OCRModal from "./components/OCRModal";
import OCRDisplayDrawer from "./components/OCRDisplayDrawer";
import LogoButton from "./components/LogoButton";
import orangeLogo from "./mLang-m-icon-orange.png";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import BulkOCRModal from "./components/BulkOCRModal";
import BatchMarkingDrawer from "./components/BatchMarkingDrawer";
import SendIcon from "@mui/icons-material/Send";
import { schoolMarkingAccess } from "./schoolMarkingAccess";

function App() {
  // Disable console.log in production
  if (process.env.REACT_APP_ENV === "production") {
    console.log = () => {};
  }
  const year = new Date().getFullYear();
  const theme = useTheme();
  const [selectedMode, setSelectedMode] = useState("select");
  const [token, setToken] = useState(null);
  const [uid, setUid] = useState(null);
  const [name, setName] = useState(null);
  const [topic, setTopic] = useState("");
  const [text, setText] = useState("");
  const [teacher, setTeacher] = useState(true);
  const [result, setResult] = useState(null);
  const [model, setModel] = useState("gpt4");
  const [markingSchemeList, setMarkingSchemeList] = useState([]);
  const [markingScheme, setMarkingScheme] = useState("");
  const [genreList, setGenreList] = useState([]);
  const [schoolAccess, setSchoolAccess] = useState({});
  //const [grade, setGrade] = useState(1);
  const [wordCounts, setWordCounts] = useState(0);
  const [genre, setGenre] = useState("");
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState("teacher");
  const [developer, setDeveloper] = useState(false);
  const [error, setError] = useState(null);
  const [history, setHistory] = useState(null);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [batchMarkingOpen, setBatchMarkingOpen] = useState(false);
  const [batchMarking, setBatchMarking] = useState(null);
  const [usage, setUsage] = useState(null);

  const [llmList, setLLMList] = useState([]);
  const [selectedLLM, setSelectedLLM] = useState("select");
  const handleLLMChange = (event) => {
    setSelectedLLM(event.target.value);
  };

  const [ocrImages, setOcrImages] = useState(null);
  const [openOCRModal, setOpenOCRModal] = useState(false);
  const [openBulkOCR, setOpenBulkOCR] = useState(false);
  const [openActionDD, setOpenActionDD] = useState(true);

  const handleModeChange = (event) => {
    setSelectedMode(event.target.value);
  };

  const handleClickedMode = () => {
    if (markingScheme === "") {
      alert("請選擇評分標準");
      return;
    }
    if (selectedLLM === "select") {
      alert("請選擇語言模型");
      return;
    }
    if (selectedMode === "recommend") {
      genFlowSuggestion(selectedLLM);
    } else if (selectedMode === "rewrite") {
      getflowRewrite(selectedLLM);
    } else if (selectedMode === "generate") {
      genFlowGen(selectedLLM);
    } else if (selectedMode === "marking") {
      mark(selectedLLM);
    } else {
      alert("請選擇mAI mind模式");
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (text !== "" || topic !== "") {
        e.preventDefault();
        e.returnValue = "所有輸入的文字將會被清除，確定要離開嗎？";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [text, topic]);

  const handleLogin = async (event) => {
    event.preventDefault();
    setError(null);
    const data = new FormData(event.currentTarget);

    await fetch(`${process.env.REACT_APP_API_HOST}/v2/user/auth`, {
      method: "POST",
      headers: {
        username: data.get("username"),
        password: data.get("password"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error > 0) {
          setError("登入名稱或密碼不正確");
        } else if (data.role === "student") {
          setError(
            "同學們！這個平台是專為老師而設的教學輔助工具。學生帳戶暫時未能登入。"
          );
        } else {
          setToken(data.token);
          setUid(data.userId);
          setName(data.name);
          setRole(data.role);
          setSchoolAccess(data.schoolAccess || {});
          console.log(data.role);
          if (data.role === "developer") {
            setDeveloper(true);
          }
        }
      })
      .catch((err) => {
        console.error(err.message);
        setError(err.message);
      });
  };

  const handleLogout = (event) => {
    setToken(null);
    setModel("gpt4");
    setGenre("");
    setText("");
    setTopic("");
    setResult(null);
    setSelectedLLM("select");
    setUid(null);
    setName(null);
  };

  const handleInput = (event) => {
    setText(event.target.value);
  };

  const handleSwitch = (event) => {
    setTeacher(!event.target.checked);
  };

  // const handleSwitchModel = (event) => {
  //   setModel(event.target.checked ? "gpt4" : "ChatGPT");
  // };

  const handleMarkingSchemeChange = (event) => {
    setMarkingScheme(event.target.value);
  };

  const handleGenreChange = (event) => {
    setGenre(event.target.value);
  };
  useEffect(() => {
    const getLLMList = async () => {
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}/v2/writing/llm`,
        {},
        {
          headers: { Authorization: "Bearer " + token },
        }
      );
      console.log("getLLMList", response);
      if (response?.data) {
        setLLMList(response.data);
      }
    };

    if (token !== null) {
      getLLMList();
    }
  }, [token]);

  useEffect(() => {
    const getMarkingSchemeList = async () => {
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}/v2/writing/markingScheme`,
        {},
        {
          headers: { Authorization: "Bearer " + token },
        }
      );
      console.log("getMarkingSchemeList", response);
      if (response?.data.success && schoolAccess.code) {
        // disable 校本評核 for schools not in schoolMarkingAccess
        const mapped = response.data.result?.map((option) => {
          const isSchoolBased = option.name === "校本評核";
          return {
            ...option,
            disabled:
              isSchoolBased && !schoolMarkingAccess.includes(schoolAccess.code),
          };
        });
        setMarkingSchemeList(mapped);
      } else if (response?.data.success) {
        const mapped = response.data.result?.map((option) => {
          const isSchoolBased = option.name === "校本評核";
          return {
            ...option,
            disabled: isSchoolBased,
          };
        });
        setMarkingSchemeList(mapped);
      }
    };
    if (token !== null) {
      getMarkingSchemeList();
    }
  }, [token]);

  useEffect(() => {
    const getGenreList = async () => {
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}/v2/writing/genre`,
        {
          //type: "genre",
        },
        {
          headers: { Authorization: "Bearer " + token },
        }
      );
      //console.log(response);
      if (response.data.success) setGenreList(response.data.result);
    };

    if (token !== null) {
      getGenreList();
    }
  }, [token]);

  const genFlowSuggestion = async (llm) => {
    setLoading(true);
    setError(null);
    const response = await axios
      .post(
        `${process.env.REACT_APP_API_HOST}/v2/writing/mind`,
        {
          input: topic.trim(),
          idea: text.trim(),
          genre: genre,
          marking_scheme: markingScheme,
          type: "flowRecommend",
          llm: llm,
        },
        {
          headers: { Authorization: "Bearer " + token },
        }
      )
      .catch((err) => {
        console.error(err.message);
        setError(err.message);
        setLoading(false);
      });
    console.log("getFlowSuggestion", response);
    if (response?.data.error > 0) {
      setError(response.data.message);
    } else {
      setResult(response?.data);
      await getUsage();
    }
    setLoading(false);
  };
  const getflowRewrite = async (llm) => {
    setLoading(true);
    setError(null);
    const response = await axios
      .post(
        `${process.env.REACT_APP_API_HOST}/v2/writing/mind`,
        {
          topic: topic.trim(),
          input: text.trim(),
          genre: genre,
          marking_scheme: markingScheme,
          type: "flowRewrite",
          llm: llm,
        },
        {
          headers: { Authorization: "Bearer " + token },
        }
      )
      .catch((err) => {
        console.error(err.message);
        setError(err.message);
        setLoading(false);
      });
    console.log("getFlowSuggestion", response);
    if (response?.data.error > 0) {
      setError(response.data.message);
    } else {
      setResult(response?.data);
      await getUsage();
    }
    setLoading(false);

    // await fetch(`${process.env.REACT_APP_API_HOST}/v2/writing/mind`, {
    //   method: "POST",
    //   body: JSON.stringify({
    //     input: topic.trim(),
    //     idea: text.trim(),
    //     marking_scheme: markingScheme,
    //     type: 'recommend',
    //   }),
  };

  const genFlowGen = async (llm) => {
    setLoading(true);
    setError(null);
    await fetch(`${process.env.REACT_APP_API_HOST}/v2/writing/mind`, {
      method: "POST",
      body: JSON.stringify({
        input: topic.trim(),
        idea: text.trim(),
        genre: genre,
        marking_scheme: markingScheme,
        type: "flowGenerate",
        llm: llm,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        if (data.error > 0) {
          setError(data.message);
        } else {
          setResult(data);
          await getUsage();
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err.message);
        setError(err.message);
        setLoading(false);
      });
  };

  const mark = async (llm) => {
    setLoading(true);
    setError(null);
    // await fetch(
    //   `${
    //     process.env.REACT_APP_API_HOST
    //   }/v2/writing/mark?ts=${new Date().getTime()}`,
    //   {
    //     method: "POST",
    //     body: JSON.stringify({
    //       writing: text.trim(),
    //       role:
    //         role === "student"
    //           ? "student"
    //           : teacher
    //           ? "teacher"
    //           : developer
    //           ? "developer"
    //           : "student",
    //       userId: uid,
    //       model: model,
    //       grade: grade,
    //       genre: genre,
    //     }),
    //     headers: {
    //       "Content-type": "application/json; charset=UTF-8",
    //       authorization: `Bearer ${token}`,
    //     },
    //   }
    // )
    //   .then((response) => response.json())
    //   .then(async (data) => {
    //     if (data.error > 0) {
    //       setError(data.message);
    //     } else {
    //       setResult(data);
    //       await getUsage();
    //     }
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     console.error(err.message);
    //     setError(err.message);
    //     setLoading(false);
    //   });

    await fetch(`${process.env.REACT_APP_API_HOST}/v2/writing/mind`, {
      method: "POST",
      body: JSON.stringify({
        topic: topic.trim(),
        input: text.trim(),
        marking_scheme: markingScheme,
        sub_marking_scheme: markingScheme === "校本評核" ? schoolAccess.code : "",
        type: "flowMark",
        genre: genre,
        llm: llm,
        ocrImages: ocrImages,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        console.log("marking response", data);
        if (data.error > 0) {
          setError(data.message);
        } else {
          setResult(data);
          await getUsage();
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err.message);
        setError(err.message);
        setLoading(false);
      });
  };

  //   console.log('mark', response);
  //   if (response.data.error > 0) {
  //     setError(response.data.message);
  //   } else {
  //     //setResult(response.data);
  //     await getUsage();
  //   }
  //   setLoading(false);
  // };

  const viewHistory = async () => {
    await fetch(`${process.env.REACT_APP_API_HOST}/v2/writing/history`, {
      method: "POST",
      body: JSON.stringify({
        page: 1,
        limit: 300,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error > 0) {
          setError(data.message);
        } else {
          setHistory(data.history);
          setHistoryOpen(true);
        }
      })
      .catch((err) => {
        console.error(err.message);
        setError(err.message);
      });
  };

  const viewBatchMarkingHistory = async () => {
    const response = await axios
      .post(
        `${process.env.REACT_APP_API_HOST}/v2/batchSubmission/getByUser`,
        {},
        {
          headers: { Authorization: "Bearer " + token },
        }
      )
      .catch((err) => {
        console.error(err.message);
        setError(err.message);
      });
    console.log("getBatchMarkingHistory", response);
    if (response.data) {
      setBatchMarking(
        response.data
          .filter((item) => item.batchMaiCallAiJobIds.length > 0)
          .sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt);
          })
      );
      setBatchMarkingOpen(true);
    }
  };
  console.log("batchMarking", batchMarking);

  const selectBatchMarkingResult = async (jobData) => {
    if (jobData) {
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}/v2/job/getDataById`,
        {
          _id: jobData._id,
          dataType: "callai",
        },
        {
          headers: { Authorization: "Bearer " + token },
        }
      );
      console.log("getBatchMarkingResult", response);
      if (response.data) {
        const data = response.data;
        if (data) {
          const newData = { createdAt: data.createdAt, ...data.data.result };
          setResult(newData);
          setText(data.filter.input);
          setTopic(data.filter.topic);
          setMarkingScheme(data.filter.marking_scheme);
          setWordCounts(data.data.wordCount);
          setGenre(data.filter.genre);
          setOcrImages(data.filter.ocrImages);
          setSelectedLLM(data.filter.llm);
        }
      }
    }
    setBatchMarkingOpen(false);
  };

  const selectResult = (resultData) => {
    if (resultData) {
      setTopic(resultData.topic);
      resultData?.settings.genre
        ? setGenre(resultData?.settings.genre)
        : setGenre("");
      setMarkingScheme(resultData.marking_scheme);
      resultData?.wordCount
        ? setWordCounts(resultData.wordCount)
        : setWordCounts(-1);
      resultData?.idea ? setText(resultData?.idea) : setText(resultData.input);
      resultData.result = resultData.output;
      if (resultData?.ocrImages) {
        setOcrImages(resultData.ocrImages);
      }
      if (resultData?.llm) {
        setSelectedLLM(
          llmList.find((llm) => llm.value === resultData.llm)?.value
            ? llmList.find((llm) => llm.value === resultData.llm)?.value
            : "select"
        );
      }
      setSelectedMode("select");
      setResult(resultData);
      setHistoryOpen(false);
    }
  };

  const handleTopicInput = (event) => {
    setTopic(event.target.value);
  };

  const getUsage = async () => {
    await fetch(`${process.env.REACT_APP_API_HOST}/v2/writing/getUsage`, {
      method: "POST",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error > 0) {
          setError(data.message);
        } else {
          setUsage(data);
        }
      })
      .catch((err) => {
        console.error(err.message);
        setError(err.message);
      });
  };

  // const downloadText = async () => {
  //   if (!result || (!result.id && !result._id)) {
  //     return null;
  //   }
  //   await fetch(
  //     `${
  //       process.env.REACT_APP_API_HOST
  //     }/v2/writing/text?ts=${new Date().getTime()}`,
  //     {
  //       method: "POST",
  //       body: JSON.stringify({
  //         id: result.id ?? result._id,
  //       }),
  //       headers: {
  //         "Content-type": "application/json; charset=UTF-8",
  //         authorization: `Bearer ${token}`,
  //       },
  //     }
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       const blob = new Blob([data.text], {
  //         type: "text/plain;charset=utf-8",
  //       });
  //       const filename =
  //         data.type === "mark"
  //           ? "評改作文"
  //           : data.role === "teacher"
  //           ? "生成範文"
  //           : "作文建議";
  //       saveAs(blob, filename);
  //     })
  //     .catch((err) => {
  //       console.error(err.message);
  //       setError(err.message);
  //     });
  // };

  const DecodeText = () => {
    let blobText;
    if (result.result && typeof result.result === "object") {
      blobText = name + " 作文\n";
      if (result._createdAt) {
        blobText += "(" + displayDate(result._createdAt) + ")\n";
      }
      blobText += "\n";
      blobText += topic + "\n";
      if (result.input) {
        blobText += result.input + "\n";
      } else {
        blobText += text;
      }
      if (result.result) {
        if (result?.marking_scheme) {
          if (
            result.marking_scheme === "DSE" ||
            result.marking_scheme === "IGCSE" ||
            result.marking_scheme === "IB"
          ) {
            blobText += `\n\n老師評語(${result.marking_scheme}(測試版)): \n`;
          } else {
            blobText += `\n\n老師評語(${result.marking_scheme}): \n`;
          }
        }
        const useSimpifiedChinese =
          result.marking_scheme === "IGCSE" || result.marking_scheme === "IB"
            ? true
            : false;

        const recordGrade = result.result;
        recordGrade.grade.forEach((item) => {
          blobText += `【${item.id}】${item.item}\n`;
          if (item.grade) blobText += `等級：${item.grade}\n`;
          // result?.marking_scheme === "Pre-S1"
          //   ? (blobText += `分數：${item.score}\n`)
          //   : "";
          if (result?.marking_scheme === "Pre-S1") {
            blobText += `分數：${item?.score}\n`;
          }
          if (item.comment && typeof item.comment === "string") {
            blobText += !useSimpifiedChinese ? `評語：\n` : `评语：\n`;
            blobText += `${item.comment}\n`;
          }
          if (item?.comment?.chinese) {
            blobText += !useSimpifiedChinese ? `評語：\n` : `评语：\n`;
            blobText += `${item.comment.chinese}\n`;
          }
          if (item?.comment?.english)
            blobText += `Comment：\n${item.comment.english}\n`;
          if (item.pros && typeof item.pros === "string") {
            blobText += !useSimpifiedChinese
              ? `應繼續保持的地方：\n`
              : `应继续保持的地方：\n`;
            blobText += `${item.pros}\n`;
          }
          if (item.cons && typeof item.cons === "string") {
            blobText += !useSimpifiedChinese
              ? `應改進的地方：\n`
              : `应改进的地方：\n`;
            blobText += `${item.cons}\n`;
          }

          if (item?.pros?.chinese) {
            blobText += !useSimpifiedChinese
              ? `應繼續保持的地方：\n`
              : `应继续保持的地方：\n`;
            blobText += `${item.pros.chinese}\n`;
          }
          if (item?.cons?.chinese) {
            blobText += !useSimpifiedChinese
              ? `應改進的地方：\n`
              : `应改进的地方：\n`;
            blobText += `\n${item.cons.chinese}\n`;
          }
          if (item?.pros?.english) {
            blobText += `Areas to Maintain: \n${item.pros.english}\n`;
          }
          if (item?.cons?.english) {
            blobText += `Areas for Improvement: \n${item.cons.english}\n`;
          }

          if (item.contents) {
            item.contents.forEach((content, index) => {
              //result += `Content ID: ${content.id}\n`;
              blobText += `【${item.id}.${index + 1}】${content.item}\n`;
              blobText += `Grade/等級: ${content.grade}\n`;
              if (content.score && markingScheme === "IGCSE") {
                blobText += `Score/分數: ${content.score}\n`;
              }
              if (content.comment && typeof content.comment === "string") {
                blobText += !useSimpifiedChinese ? `評語：\n` : `评语：\n`;
                blobText += `${content.comment}\n`;
              }
              if (content?.comment?.chinese) {
                blobText += !useSimpifiedChinese ? `評語：\n` : `评语：\n`;
                blobText += `${content.comment.chinese}\n`;
              }
              if (content?.comment?.english)
                blobText += `Comment：\n${content.comment.english}\n`;
              if (content.pros && typeof content.pros === "string") {
                blobText += !useSimpifiedChinese
                  ? `應繼續保持的地方：\n`
                  : `应继续保持的地方：\n`;
                blobText += `${content.pros}\n`;
              }
              if (content.cons && typeof content.cons === "string") {
                blobText += !useSimpifiedChinese
                  ? `應改進的地方：\n`
                  : `应改进的地方：\n`;
                blobText += `${content.cons}\n`;
              }
              if (content?.pros?.chinese) {
                blobText += !useSimpifiedChinese
                  ? `應繼續保持的地方：\n`
                  : `应继续保持的地方：\n`;
                blobText += `${content.pros.chinese}\n`;
              }
              if (content?.cons?.chinese) {
                blobText += !useSimpifiedChinese
                  ? `應改進的地方：\n`
                  : `应改进的地方：\n`;
                blobText += `${content.cons.chinese}\n`;
              }
              if (content?.pros?.english) {
                blobText += `Areas to Maintain: \n${content.pros.english}\n`;
              }
              if (content?.cons?.english) {
                blobText += `Areas for Improvement: \n${content.cons.english}\n`;
              }
              blobText += "\n";
            });
          }
          blobText += "\n";
        });

        if (recordGrade.overall) {
          if (recordGrade?.overall?.item) {
            blobText += `【${recordGrade.overall.item}】\n`;
          } else {
            blobText += "整體評核：\n";
          }
          if (recordGrade.overall.grade) {
            blobText += `等級： ${recordGrade.overall.grade}\n`;
          }
          if (
            recordGrade.overall.comment &&
            typeof recordGrade.overall.comment === "string"
          ) {
            blobText += !useSimpifiedChinese ? `評語：\n` : `评语：\n`;
            blobText += `${recordGrade.overall.comment}\n\n`;
          }
          if (recordGrade.overall.comment.chinese) {
            blobText += !useSimpifiedChinese ? `評語：\n` : `评语：\n`;
            blobText += `${recordGrade.overall.comment.chinese}\n\n`;
          }
          if (recordGrade.overall.comment.english) {
            blobText += `Comment： \n${recordGrade.overall.comment.chinese}\n\n`;
          }
        }
        if (recordGrade.suggestion) {
          if (recordGrade?.suggestion?.item) {
            blobText += `【${recordGrade.suggestion.item}】\n`;
          } else {
            blobText += "改進建議：\n";
          }
          if (
            recordGrade.suggestion.comment &&
            typeof recordGrade.suggestion.comment === "string"
          ) {
            blobText += !useSimpifiedChinese ? `評語：\n` : `评语：\n`;
            blobText += `${recordGrade.suggestion.comment}\n\n`;
          }
          if (recordGrade.suggestion.comment.chinese) {
            blobText += !useSimpifiedChinese ? `評語：\n` : `评语：\n`;
            blobText += `${recordGrade.suggestion.comment.chinese}\n\n`;
          }
          if (recordGrade.suggestion.comment.english) {
            blobText += `Comment： \n${recordGrade.suggestion.comment.chinese}\n\n`;
          }
        }
        if (recordGrade?.totalScore) {
          blobText += `Total Score/总分: ${recordGrade.totalScore}\n\n`;
        }
        if (result?.vocab) {
          blobText += `【《香港小學學習字詞表》第一學習階段字詞】（${result.vocab?.stage1.length}個）:\n`;
          blobText += result.vocab?.stage1.join(", ") + "\n\n";

          blobText += `【《香港小學學習字詞表》第二學習階段字詞】（${result.vocab?.stage2.length}個）:\n`;
          blobText += result.vocab?.stage2.join(", ") + "\n\n";
        }
      }

      let filename = name + " - 作文 " + topic + " 評改作文(老師版)";

      if (result?._createdAt) {
        filename = filename + " (" + displayDate(result?._createdAt) + ")";
      }

      console.log("blobText", blobText);
      const blob = new Blob([blobText], { type: "text/plain;charset=utf-8" });
      saveAs(blob, filename);
    } else {
      blobText = result.result;

      console.log("blobText", blobText);
      const blob = new Blob([blobText], { type: "text/plain;charset=utf-8" });
      let filename = name + " - 作文 " + topic + " 範文/建議";
      saveAs(blob, filename);
    }
  };

  useEffect(() => {
    if (token) {
      const onLoad = async () => {
        await getUsage();
      };
      onLoad();
    }
  }, [token]);

  useEffect(() => {
    if (text) {
      setWordCounts(countChineseCharacters(text.trim()));
    }
  }, [text]);

  if (!token || !uid) {
    return <Login loginFn={handleLogin} message={error} />;
  }

  return (
    <>
      <Header
        username={name}
        logoutFn={handleLogout}
        genFn={genFlowGen}
        recommendFn={genFlowSuggestion}
        llmList={llmList}
        markFn={mark}
        batchHistoryFn={viewBatchMarkingHistory}
        historyFn={viewHistory}
        bulkOCRFn={setOpenBulkOCR}
        //switchModelFn={handleSwitchModel}
        model={model}
        role={role}
        teacher={teacher}
        switchRoleFn={handleSwitch}
        loading={loading}
      />
      <Backdrop sx={{ color: "#fff", zIndex: 999 }} open={loading}>
        <CircularProgress color="warning" />
        <Typography variant="h6" color="warning" sx={{ ml: 2 }}>
          你的要求已提交mAI mind，生成結果需時一至兩分鐘，請耐心等候。
        </Typography>
      </Backdrop>
      <Container>
        <Grid container sx={{ mt: 8, pt: 3 }}>
          {error && (
            <Alert severity="error" sx={{ width: "100%", my: 3 }}>
              {error}
            </Alert>
          )}
          <Grid item xs={12} md={3}>
            <Select
              id="markingScheme"
              value={markingScheme}
              onChange={handleMarkingSchemeChange}
              sx={{ width: "100%" }}
              displayEmpty
            >
              <MenuItem value="">
                <em>請選擇評分標準</em>
              </MenuItem>
              {markingSchemeList?.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option.name}
                  disabled={option.disabled}
                >
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={12} md={3}>
            <Select
              id="genre"
              value={genre}
              /* label='文體'  */ onChange={handleGenreChange}
              sx={{ width: "100%" }}
              displayEmpty
            >
              <MenuItem value="">
                <em>不指定文體</em>
              </MenuItem>
              {genreList?.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option.name}
                  disabled={option.disabled}
                >
                  {option.name}
                </MenuItem>
              ))}
              {/* <MenuItem value={"描寫文"}>描寫文</MenuItem>
              <MenuItem value={"說明文"}>說明文</MenuItem>
              <MenuItem value={"記敍文"}>記敍文</MenuItem>
              <MenuItem value={"抒情文"}>抒情文</MenuItem>
              <MenuItem value={"議論文"}>議論文</MenuItem> */}
              {/* <MenuItem value={'書信'}>實用文 - 書信</MenuItem> */}
            </Select>
          </Grid>
          <Grid item xs={12} md={5} sx={{ alignSelf: "center" }}>
            <Usage data={usage} developer={developer} />
          </Grid>
          <Grid item xs={12} md={1} sx={{ alignSelf: "center" }}>
            <Button
              aria-label="下載"
              size="large"
              color="primary"
              variant="contained"
              disabled={result === null}
              onClick={DecodeText}
              fullWidth
            >
              <DownloadIcon />
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card sx={{ height: "100%" }}>
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  //alignItems: "stretch",
                }}
              >
                <Stack
                  direction="column"
                  spacing={1}
                  sx={{ width: "100%", height: "100%" }}
                >
                  <TextField
                    multiline
                    fullWidth
                    //sx={{ width: "100%", height: "100%", display: "flex" }}
                    rows={3}
                    placeholder="請輸入作文題目"
                    label="作文題目"
                    value={topic}
                    onChange={handleTopicInput}
                    variant="filled"
                  />
                  <Stack sx={{ m: 1 }}>
                    <Button
                      variant="contained"
                      size="medium"
                      color="primary"
                      onClick={() => setOpenOCRModal(true)}
                    >
                      <DocumentScannerIcon sx={{ mr: 1 }} />
                      OCR
                    </Button>
                  </Stack>
                  <TextField
                    multiline
                    fullWidth
                    //sx={{ width: "100%", height: "100%", display: "flex" }}
                    rows={18}
                    placeholder="輸入整篇文章以進行評改 或 內容大意以生成範文/建議"
                    label="整篇文章 或 內容大意 (可選填)"
                    value={text}
                    onChange={handleInput}
                    variant="filled"
                  />
                  {ocrImages && ocrImages.length > 0 && (
                    <OCRDisplayDrawer
                      ocrImages={ocrImages}
                      setOcrImages={setOcrImages}
                    />
                  )}
                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                      width: "100%",
                      mb: 1,
                      //alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {wordCounts >= 0 ? (
                      <Typography
                        variant="body2"
                        sx={{ color: "#707070", ml: 0 }}
                      >
                        字數: {wordCounts}
                      </Typography>
                    ) : (
                      ""
                    )}
                    <Box sx={{ position: "relative" }}>
                      {/* <Button
                        size="large"
                        variant="contained"
                        endIcon={<ArrowDropDownIcon />}
                        onClick={() => {
                          setOpenActionDD(!openActionDD);
                        }}
                        sx={{
                          backgroundColor: "#4B9560",
                          textTransform: "none",
                        }}
                      >
                        mAI mind
                      </Button> */}
                      <LogoButton
                        onClick={() => {
                          setOpenActionDD(!openActionDD);
                        }}
                        isDisabled={true}
                        logoSrc={orangeLogo}
                        buttonText={"mAI mind"}
                      />
                    </Box>
                    {/* <Button
                      variant="contained"
                      size="medium"
                      color="primary"
                      onClick={() => setOpenOCRModal(true)}
                    >
                      <DocumentScannerIcon sx={{ mr: 1 }} />
                      OCR (測試版)
                    </Button> */}
                  </Stack>
                  <Stack>
                    {openActionDD && (
                      <Box
                        sx={{
                          position: "relative",
                          p: 2,
                          backgroundColor: "white",
                          borderRadius: 3,
                        }}
                      >
                        <Stack direction="column" spacing={2}>
                          <FormControl
                            fullWidth
                            variant="outlined"
                            margin="normal"
                          >
                            <InputLabel id="mode-select-label">
                              選擇模式
                            </InputLabel>
                            <Select
                              value={selectedMode}
                              onChange={handleModeChange}
                              label="選擇模式"
                              labelId="mode-select-label"
                            >
                              <MenuItem value="select">
                                請選擇mAI mind模式
                              </MenuItem>
                              <MenuItem value="generate">生成範文</MenuItem>
                              <MenuItem value="rewrite">作文改寫</MenuItem>
                              <MenuItem value="recommend">作文建議</MenuItem>
                              <MenuItem value="marking">評改作文</MenuItem>
                            </Select>
                          </FormControl>
                          <Stack
                            direction="row"
                            alignItems={"center"}
                            spacing={1}
                          >
                            <FormControl
                              sx={{ ml: 1 }}
                              //width="100%"
                              size="large"
                            >
                              <InputLabel id="llm-select-label">
                                語言模型
                              </InputLabel>
                              <Select
                                labelId="llm-select-label"
                                id="llm-select"
                                value={selectedLLM}
                                onChange={handleLLMChange}
                                label="llm-select-label"
                              >
                                <MenuItem value="select">
                                  請選擇語言模型
                                </MenuItem>
                                {llmList.map((llm) => (
                                  <MenuItem value={llm.value} key={llm.value}>
                                    {llm.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            <Box sx={{ flexGrow: 1 }} />
                            <Fab
                              size="medium"
                              color="secondary"
                              aria-label="send"
                              onClick={handleClickedMode}
                            >
                              <SendIcon />
                            </Fab>
                          </Stack>
                          {/* <Button
                            size="large"
                            variant="contained"
                            endIcon={<ArrowForwardIcon />}
                            sx={{
                              backgroundColor: "#f1f1f1",
                              color: "#0071E3",
                            }}
                            onClick={() => {
                              genFlowGen(selectedLLM);
                            }}
                          >
                            生成範文
                          </Button>
                          <Button
                            size="large"
                            variant="contained"
                            sx={{
                              backgroundColor: "#f1f1f1",
                              color: "#0071E3",
                            }}
                            endIcon={<ArrowForwardIcon />}
                            onClick={() => {
                              genFlowSuggestion(selectedLLM);
                            }}
                          >
                            作文建議
                          </Button>
                          <Button
                            size="large"
                            variant="contained"
                            endIcon={<ArrowForwardIcon />}
                            sx={{
                              backgroundColor: "#f1f1f1",
                              color: "#0071E3",
                            }}
                            onClick={() => {
                              getflowRewrite(selectedLLM);
                            }}
                          >
                            作文改寫
                          </Button>
                          <Button
                            size="large"
                            variant="contained"
                            endIcon={<ArrowForwardIcon />}
                            sx={{
                              backgroundColor: "#f1f1f1",
                              color: "#0071E3",
                            }}
                            onClick={() => {
                              mark(selectedLLM);
                            }}
                          >
                            評改作文
                          </Button> */}
                        </Stack>
                      </Box>
                    )}
                  </Stack>
                </Stack>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                height: "100%",
                whiteSpace: "pre-wrap",
                bgcolor: grey[100],
                p: 2,
                boxSizing: "border-box",
              }}
            >
              <Result data={result} llmList={llmList} schoolAccess={schoolAccess} />
            </Card>
          </Grid>
        </Grid>
        <HistoryDrawer
          historyData={history}
          state={historyOpen}
          setDrawer={setHistoryOpen}
          resultFn={selectResult}
        />
        <BatchMarkingDrawer
          batchHistoryData={batchMarking}
          state={batchMarkingOpen}
          setDrawer={setBatchMarkingOpen}
          resultFn={selectBatchMarkingResult}
          token={token}
        />
        <OCRModal
          state={openOCRModal}
          setOpen={setOpenOCRModal}
          text={text}
          setText={setText}
          setOcrImages={setOcrImages}
          ocrImages={ocrImages}
          token={token}
        />
        <BulkOCRModal
          open={openBulkOCR}
          setOpen={setOpenBulkOCR}
          developer={developer}
          genreList={genreList}
          markingSchemeList={markingSchemeList}
          llmList={llmList}
          usage={usage}
          getUsageFn={getUsage}
          token={token}
        />
        {/* <Box sx={{ mt: 2, textAlign: 'center' }}>
        <ButtonGroup variant='contained' size='large'>
          <Button onClick={gen}>
            <Typography variant='h4'>{teacher ? '生成範文' : '作文建議'}</Typography>
          </Button>
          <Button onClick={mark} color='secondary'>
            <Typography variant='h4'>評改作文</Typography>
          </Button>
        </ButtonGroup>
      </Box> */}
        <Box sx={{ mt: 3 }}>&copy; m-Chinese Solution Limited {year}</Box>
        <Box sx={{ textAlign: "right" }}>
          <img src="/logo_128.png" alt="mLang" />
        </Box>
      </Container>
    </>
  );
}

export default App;
